import { NotificationSettings } from '#/widgets/notification-settings';
import { Paper, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

export default function NotificationSettingsPage() {
  const { t } = useTranslation();

  return (
    <Paper bg="white" radius="md" p={{ base: 'xs', sm: 'md' }}>
      <Text fw={500} fz="md" mb="md">
        {t('profile.notificationSettings')}
      </Text>

      <Stack w="100%">
        <NotificationSettings />
      </Stack>
    </Paper>
  );
}
